import { render, staticRenderFns } from "./RouteOrderManager.vue?vue&type=template&id=4522b7c1&"
import script from "./RouteOrderManager.vue?vue&type=script&lang=js&"
export * from "./RouteOrderManager.vue?vue&type=script&lang=js&"
import style0 from "./RouteOrderManager.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports